
require('../test/envelope.test');
require('../test/recrypt.test');
require('../test/lib.test');